<template>
  <div class="home">
    <Welcome v-if="false" />
    <WelcomeAlt v-if="true" />
<!--    <WelcomeToMortgageWatch include-cta />-->
    <IntroductionToMortgageWatch include-cta/>
    <IntroductionToRemortgage v-if="true" size="lg" include-cta/>
    <HowItWorks/>
    <RegularAlerts/>
    <FreeMortgageWatchAlert />
    <FavouriteLenders />
    <Testimonials />
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from "@/components/home/Welcome.vue";
import WelcomeAlt from "@/components/home/WelcomeAlt.vue";
import FavouriteLenders from "@/components/home/FavouriteLenders.vue";
import Testimonials from "@/components/home/Testimonials";
import IntroductionToRemortgage from "@/components/home/IntroductionToRemortgage";
import IntroductionToMortgageWatch from "@/components/home/IntroductionToMortgageWatch";
import WelcomeToMortgageWatch from "@/components/home/WelcomeToMortgageWatch";
import FreeMortgageWatchAlert from "@/components/home/FreeMortgageWatchAlert";
import HowItWorks from "@/components/home/HowItWorks";
import RegularAlerts from "@/components/home/RegularAlerts";

export default {
  name: "Home",
  components: {
    RegularAlerts,
    HowItWorks,
    FreeMortgageWatchAlert,
    IntroductionToMortgageWatch,
    Welcome,
    WelcomeAlt,
    IntroductionToRemortgage,
    FavouriteLenders,
    Testimonials
  }
};
</script>